import React, { Component } from "react";
import "../App.css";
import { getText } from "../Text";
import map from "../static/img/mapv2.png"
import map_english from "../static/img/mapv2_english.png"

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

class Contact extends Component {
	render() {
		const language = this.props.language
		return (
			<div className="Contact">
				<div className="map" style={{backgroundImage: language === 'CN' ? `url(${map})` : `url(${map_english})`}}>
					<Container>
						<div className="bg-text">
							<h1 className="contact"> {getText(language).contact_page.header}</h1>
						</div>
					</Container>
				</div>
				<Container>
                    <Row xs={1} xl={2}>
                        <Col className="contactHeader">
							<div className="contactDiv">
								<b>{getText(language).contact_page.mobile}: </b>{getText(language).contact_page.mobile_num}<br/>
								<b>{getText(language).contact_page.fax}: </b>{getText(language).contact_page.phone}<br/>
							</div>
                        </Col>
                        <Col className="contactHeader">
							<div className='contactDiv addressDiv'>
								<b>{getText(language).contact_page.email}: </b>info@shppc.com<br/>
								<b>{getText(language).contact_page.address}: </b>{getText(language).contact_page.address1}<br/>
								{"           "}{getText(language).contact_page.address2}
							</div>
                        </Col>
                    </Row>
                </Container>
			</div>
		);
	}
}

export default Contact;
